import { GlobalThemeType } from '../../themes/types';

export interface BooleanProps {
  bold: string;
  semibold: string;
  italic: string;
  centered: string;
  uppercase: string;
  nowrap: string;
  block: string;

  primary: string;
  secondary: string;
  white: string;
  success: string;
  danger: string;
  warning: string;
  dark: string;
}

export const BOOLEAN_PROPS = (theme: GlobalThemeType): BooleanProps => ({
  bold: 'font-weight: 700;',
  semibold: 'font-weight: 600;',
  italic: 'font-style: italic;',
  centered: 'text-align: center;',
  uppercase: 'text-transform: uppercase;',
  nowrap: 'white-space: nowrap;',
  block: 'display: block;',

  primary: `color: ${theme.text.primary};`,
  secondary: `color: ${theme.text.secondary};`,
  white: 'color: white;',
  success: `color: ${theme.states.success.default};`,
  danger: `color: ${theme.states.danger.default};`,
  warning: `color: ${theme.states.warning.default};`,
  dark: `color: ${theme.colors.black.default};`,
});

export const PROP_NAMES = ['color', 'line-height', 'letter-spacing'];

interface TextStyleProps {
  propNames: typeof PROP_NAMES;
  booleanProps: BooleanProps;
}

export const defaultTextStyleProps = (
  theme: GlobalThemeType,
): TextStyleProps => ({
  propNames: PROP_NAMES,
  booleanProps: BOOLEAN_PROPS(theme),
});
